import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const StrategyGovernance = () => {

   <ScrollToTop />
  return (
    <>
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Strategy, Governance & Institutional Capacity Development</h1>
          <p className="lead">
            We support organisations and public institutions to strengthen governance, strategy, and operational systems for sustainable and inclusive impact.
          </p>
        </div>
      </section>

      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Organisational assessments and governance diagnostics</strong>
              <p>Identifying strengths, gaps, risks, and reform priorities through structured analysis.</p>
            </li>
            <li>
              <strong>Strategic planning and results-based management</strong>
              <p>Aligning vision, goals, and resources with clear, measurable outcomes and accountability.</p>
            </li>
            <li>
              <strong>Programme and business model design</strong>
              <p>Innovative, sustainable approaches tailored to context and stakeholder needs.</p>
            </li>
            <li>
              <strong>Change management and leadership coaching</strong>
              <p>Supporting transitions, building resilience, and developing strong leadership capacity.</p>
            </li>
            <li>
              <strong>Policy and institutional reform advisory</strong>
              <p>Evidence-based guidance to drive systemic improvements and policy effectiveness.</p>
            </li>
          </ul>

          <div className="cta-section">
            <h3>Ready to Strengthen Your Organisation?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Begin Your Institutional Strengthening <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        {/* Paste the full footer here */}
      </footer>
    </>
  );
};

export default StrategyGovernance;